import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const minutes = 15

// js-cookie 的示例中只有以天为单位的有效期：
// Cookies.set('name', 'value', { expires: 7 });
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, {expires: minutes / 24 / 60 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
